import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	makeStyles,
	TextField,
	Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { get } from "lodash";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useMutation, useNotify, useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	actions: {
		alignItems: "flex-start",
	},
	actionsNotAttempts: {
		alignItems: "center",
	},
	attempts: {
		paddingLeft: theme.spacing(1),
	},
}));

const ApprovalDialog = ({ deal, onClose }) => {
	const classes = useStyles();
	const translate = useTranslate();
	const notify = useNotify();
	const [notes, setNotes] = useState(deal.approval ? deal.approval.notes : "");
	const supervisorNotes = get(deal, "approval.supervisor_notes");
	const attempts = get(deal, "approval.attempts");
	const canTry = attempts === undefined || attempts > 0;
	const rejected = get(deal, "approval.status", "none") === "rejected";
	const handleChange = (e) => setNotes(e.target.value);
	const handleClose = () => onClose(deal);
	const approvalType = deal.approval ? "update" : "create";
	const [requestApproval, { loading }] = useMutation(
		{
			type: approvalType,
			resource: "bookmaker-approvals",
			payload: {
				id: deal.approval ? deal.approval.id : null,
				data: {
					...(deal.approval || { bookmaker_id: deal.id }),
					notes,
					approvalType,
				},
			},
		},
		{
			onSuccess: ({ data }) => {
				onClose(deal, true);
				notify(
					translate(`resources.bookmaker-approvals.messages.${approvalType}`)
				);
			},
			onFailure: (error) => {
				onClose(deal, false);
				notify(
					translate("resources.bookmaker-approvals.messages.fail"),
					"warning"
				);
			},
		}
	);
	return (
		<Dialog open={deal !== null} maxWidth="sm" fullWidth>
			<DialogTitle>
				{translate(`resources.bookmaker-approvals.titles.${approvalType}`)}
			</DialogTitle>
			<DialogContent>
				{supervisorNotes && rejected && (
					<DialogContentText component="div">
						<Alert severity="warning">
							{translate(
								"resources.bookmaker-approvals.helpers.supervisor_notes"
							)}
							<strong>{supervisorNotes}</strong>
						</Alert>
					</DialogContentText>
				)}
				{canTry ? (
					<>
						<DialogContentText component="div">
							<Alert severity="info">
								{translate("resources.bookmaker-approvals.help")}
							</Alert>
						</DialogContentText>
						<TextField
							value={notes}
							onChange={handleChange}
							autoFocus
							required
							margin="dense"
							id="notes"
							label={translate("resources.bookmaker-approvals.fields.notes")}
							type="text"
							multiline
							rows={5}
							fullWidth
						/>
					</>
				) : (
					<Alert severity="error">
						{translate("resources.bookmaker-approvals.helpers.max_attempts")}
					</Alert>
				)}
			</DialogContent>
			<DialogActions
				className={canTry ? classes.actions : classes.actionsNotAttempts}
			>
				<div>
					{canTry && (
						<Button onClick={requestApproval} disabled={loading}>
							{translate(
								`resources.bookmaker-approvals.buttons.${approvalType}`
							)}
						</Button>
					)}
					{attempts !== undefined && (
						<Typography
							color="textSecondary"
							variant="caption"
							className={classes.attempts}
							component="p"
						>
							{translate("resources.bookmaker-approvals.fields.attempts")}:{" "}
							{attempts}
						</Typography>
					)}
				</div>
				<Button onClick={handleClose} disabled={loading}>
					{translate("ra.action.cancel")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
ApprovalDialog.propTypes = {
	id: PropTypes.number,
	deal: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
};
export default ApprovalDialog;
